import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Graphics } from '@inlet/react-pixi';
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { useDrawTagCircle } from 'components/powerFlowShared/hooks/useDrawTagCircle';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { TagModal } from '../../modals/tag';
import { TagOperation } from '../types';
const translatePayload = (node) => {
    const { nextNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: nextNodeId || uuid(),
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { nextNodeId: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const TagsNodeAttributes = {
    iconName: 'tag',
    label: 'Tags',
    color: hexStringToNumber(flowNodeColor.blue),
    translatePayload,
    updateConnection,
    NodeContent: TagsNode,
    ActionModal: TagModal,
};
export function TagsNode({ node }) {
    const { payload } = node;
    const { operation, tags } = payload;
    const [firstTag] = tags;
    const drawTagCircle = useDrawTagCircle(firstTag, { x: 5, y: 35 });
    const labelEndCharacter = tags.length !== 1 ? 's' : '';
    const label = operation === TagOperation.TAG
        ? `Add tag${labelEndCharacter}:`
        : `Remove tag${labelEndCharacter}:`;
    return (_jsxs(_Fragment, { children: [_jsx(TextContent, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "normal", text: label }) })), [label]) }), _jsx(Graphics, { draw: drawTagCircle }), _jsx(TextContent, Object.assign({ width: 200, offset: { x: 15, y: 22 } }, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: (firstTag === null || firstTag === void 0 ? void 0 : firstTag.name) || 'unknown tag' }) })), [firstTag]) })), _jsx(TextContent, Object.assign({ width: 230, offset: { x: 200, y: 22 } }, { children: useMemo(() => {
                    if (tags.length < 2) {
                        return _jsx(_Fragment, {});
                    }
                    return (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "normal", text: `+${tags.length - 1}` }) }));
                }, [tags.length]) }))] }));
}
